import axios from "axios";
import {globalApi } from "./globalFunctions";

export default axios.create({
       baseURL:  `${globalApi}`,
});
